import { Injectable } from '@angular/core';
import { Observable, catchError, concatMap, map, of } from 'rxjs';
import { ApiService } from 'src/app/core/service/api.service';
import { InvisibleRecaptchaService } from 'src/app/core/service/invisible-recaptcha.service';

@Injectable({
  providedIn: 'root',
})
export class FilePresignUrlUploadService {
  action: string = 'register_complete';

  constructor(public apiSrv: ApiService, private readonly captchaSrv: InvisibleRecaptchaService) {}

  getPresignUrlUpload(filename: string, type: string): Observable<any> {
    let body = { filename: filename, type: type };
    return this.captchaSrv
      .getCaptcha(this.action)
      .pipe(catchError(() => of('Error consiguiendo el captcha')))
      .pipe(
        map((token) => ({
          ...body,
          captcha: token,
        })),
      )
      .pipe(
        concatMap((data) =>
          this.apiSrv.post('api/presign-upload-url', data, {
            showError: true,
            ngxSpinner: true,
          }),
        ),
      );
  }

  deleteFileBucket(filename: string): Observable<any> {
    let body = { filename: filename };
    return this.captchaSrv
      .getCaptcha(this.action)
      .pipe(catchError(() => of('Error consiguiendo el captcha')))
      .pipe(
        map((token) => ({
          ...body,
          captcha: token,
        })),
      )
      .pipe(
        concatMap((data) =>
          this.apiSrv.post('api/delete-file-bucket', data, {
            showError: false,
            ngxSpinner: false,
          }),
        ),
      );
  }
}